import '../styling/NewSignupForm.css';
import team from '../resources/happyteam.jpg';
import { Link } from "react-router-dom";
import {useState} from 'react'
// We use this hook to sign the user up!
import {useSignup} from "../hooks/useSignup"

const NewSignup = () => {

    
    const [firstname,setFirstName] = useState('')
    const[lastname,setLastName] = useState('')
    const[email,setEmail] = useState('')
    const[password,setPassword] = useState('')
    // We are grabbing the signup function from the hook
    const{signup,isLoading,error} = useSignup();
    const handleSubmit = async(e) => {
        e.preventDefault();
        await signup(firstname,lastname,email,password,isLoading)
    }


    return ( 
        <div className="signupcontainer">
            <div className="signupleft">
                <form onSubmit={handleSubmit} id="signupform">
                
                    <h1 id="signuptry">Try InvoiceMaster Pro Free Today!</h1>
                    <div className="signupnames">
                    <input type="text" placeholder="First Name" className="input input-bordered input-info w-half max-w-xs" value={firstname} onChange={(e) => setFirstName(e.target.value)}/>
                    <input type="text" id="ln" placeholder="Last Name" className="input input-bordered input-info w-half max-w-xs" value={lastname} onChange={(e) => setLastName(e.target.value)}/>
                    </div>
                    <div className="signupemail">
                    <input type="email" placeholder="Email" className="input input-bordered input-info w-full max-w-m" value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <div className="signupemail">
                    <input type="password" placeholder="Password" className="input input-bordered input-info w-full max-w-m" value={password} onChange={(e) => setPassword(e.target.value)}/>
                    </div>
                    <div className="signupremember">
                    <input id="link-checkbox" type="checkbox" value="" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
                    <h2>I accept the Terms of Use & Privacy Policy</h2>
                    </div>
                    <div className="signupsubmit">
                    {isLoading ? <span className="loading loading-spinner text-info"></span> : <button className="btn">Submit</button>}
                    </div>
                    <div className="signupalready">
                        <h2>Already have an account?</h2>
                        <Link to="/login" style={{textDecoration: 'none'}}>
                        <h2 id="loginhere">Login here</h2>
                        </Link>
                    </div>
                    
        
                    
                    </form>   
            </div>
            <div class="signupright">
            <img src={team} alt="team" id="team" />
            <h1 id="signuprightwork">Work Simpler. Grow Smarter.</h1>
            <h1 id="signupbenefits">Reduce paperwork & admin tasks</h1>
            <h1 id="signupbenefits1">Boost revenue & profitability</h1>
            <h1 id="signupbenefits2">Exceed customer expectations</h1>
            <h1 id="signupbenefits3">Improves Client Communication</h1>
            <h1 id="signupbenefits4">Minimizes Payment Delays</h1>
            </div>


        </div>
     );
}
 
export default NewSignup;